import React from 'react';
import { Badge } from '@mantine/core';
import { IconStarFilled } from '@tabler/icons-react';

type StoreNumberBadgeProps = {
    storeNo: string;
    isChampion?: boolean;
};

export function StoreNumberBadge({
    storeNo,
    isChampion = false,
}: StoreNumberBadgeProps) {
    return (
        <Badge
            size="sm"
            color={isChampion ? 'yellow' : 'primary'}
            variant="outline"
            radius="xl"
            tt="none"
            leftSection={
                isChampion ? (
                    <IconStarFilled
                        size={12}
                        className="text-yellow-500"
                        aria-hidden
                    />
                ) : undefined
            }
            className={
                isChampion
                    ? 'flex-shrink-0 border-yellow-500 text-yellow-600 hover:bg-yellow-100/70 max-w-[240px]'
                    : 'flex-shrink-0 border-primary text-primary hover:bg-primary/10 max-w-[240px]'
            }
            classNames={{
                root: 'inline-flex items-center',
                section: 'inline-flex items-center leading-none',
                label: 'leading-none truncate',
            }}
        >
            {storeNo}
        </Badge>
    );
}
